export const utilities = {
  formatPhoneNumber,
  sanitizePhoneNumber,
  getMonthName,
  convertTo24H,
  getLanguageId,
  validDeviceType,
  deviceInfo,
  ClientTypeIdToDevice,
  ClientTypeIdToDeviceType,
  encodeStory,
  decodeStory,
  programTypeFilter,
  normalizeApiFieldValue,
  normalizeAddressComponents,
  normalizeCountryForPlus,
  normalizeEnrolleeSessionData,
  isMissingOrDefaultEnrollmentCode,
};

function isMissingOrDefaultEnrollmentCode(enrollmentCodeData) {
  const enrollmentCode =
    typeof enrollmentCodeData === "string"
      ? enrollmentCodeData
      : enrollmentCodeData?.enrollmentCode ??
        enrollmentCodeData?.EnrollmentCode;

  if (!enrollmentCode) {
    const enrollmentCodeId =
      enrollmentCodeData?.enrollmentCodeId ??
      enrollmentCodeData?.EnrollmentCodeId ??
      enrollmentCodeData?.EnrollmentCodeID;

    return !enrollmentCodeId;
  }

  const normalizedCode = String(enrollmentCode)
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

  return normalizedCode.startsWith("LIFESAFERDEFAULT");
}

function normalizeEnrolleeSessionData(data) {
  if (!data || typeof data !== "object") return data;

  const normalizedData = { ...data };
  const enrollmentCodeId =
    normalizedData.enrollmentCodeId ??
    normalizedData.EnrollmentCodeId ??
    normalizedData.EnrollmentCodeID;

  if (enrollmentCodeId !== undefined) {
    normalizedData.enrollmentCodeId = enrollmentCodeId;
  }

  delete normalizedData.EnrollmentCodeId;
  delete normalizedData.EnrollmentCodeID;

  return normalizedData;
}

function normalizeApiFieldValue(value) {
  if (typeof value === "string" && value.trim().toUpperCase() === "CE - NEED") {
    return null;
  }

  return value;
}

function formatPhoneNumber(phone) {
  if (phone === null || phone === undefined) {
    return "";
  } else {
    // const cleanedPhone = (phone || "")?.toString()?.replace(/\D/g, "");
    phone = (phone || "")?.toString()?.replace(/\D/g, "");
    if (phone.length < 10) {
      return "";
    } else {
      const match = phone.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
      if (match) {
        phone = `(${match[1]}${match[2] ? ") " : ""}${match[2]}${
          match[3] ? "-" : ""
        }${match[3]}${match[4] ? " x" : ""}${match[4]}`;
      }
      return phone;
    }
  }
}
/**
 * Sanitize a phone number to display to a user.
 * @param {string} phoneNumber Phone number to sanitize
 * @returns Sanitized phone number in the format xxx-xxx-1234
 */
function sanitizePhoneNumber(phoneNumber) {
  let lastFourNumbers = phoneNumber.slice(-4);
  return `***-***-${lastFourNumbers}`;
}

function getMonthName(objDate) {
  var locale = "en-us",
    month = objDate.toLocaleString(locale, { month: "long" });

  return month;
}

function convertTo24H(time) {
  var hours = Number(time.match(/^(\d+)/)[1]);
  var minutes = Number(time.match(/:(\d+)/)[1]);
  var AMPM = time.match(/\s(.*)$/)[1];
  if (AMPM == "PM" && hours < 12) hours = hours + 12;
  if (AMPM == "AM" && hours == 12) hours = hours - 12;
  var sHours = hours.toString();
  var sMinutes = minutes.toString();
  if (hours < 10) sHours = "0" + sHours;
  if (minutes < 10) sMinutes = "0" + sMinutes;
  return sHours + ":" + sMinutes + ":00";
}

function getLanguageId(language) {
  // default to 1 / english to avoid null / undefined errors
  if (language === null || language === undefined) return 1;

  if (language.toLowerCase().includes("en")) {
    return 1;
  } else if (language.toLowerCase().includes("es")) {
    return 2;
  } else if (language.toLowerCase().includes("it")) {
    return 9;
  } else {
    return 1; // if anything else default to english
  }
}

function validDeviceType(deviceType) {
  if (
    deviceType === null ||
    deviceType === undefined ||
    typeof deviceType !== "string"
  )
    return false;

  let deviceTypes = ["interlock", "portable", "speed", "speedv"];
  let result = deviceTypes.includes(deviceType.toLowerCase());
  return result;
}

function deviceInfo(deviceType) {
  if (deviceType && typeof deviceType === "string") {
    deviceType = deviceType?.toLowerCase();
  }

  if (deviceType === "iid" || deviceType === "interlock" || deviceType === 1) {
    return {
      device: "IID",
      deviceType: "Interlock",
      deviceTypeId: 1,
    };
  }
  if (deviceType === "pam" || deviceType === "portable" || deviceType === 5) {
    return {
      device: "PAM",
      deviceType: "Portable",
      deviceTypeId: 5,
    };
  }
  if (
    deviceType === "speed" ||
    deviceType === "speedv" ||
    deviceType === "isa" ||
    deviceType === 6
  ) {
    return {
      device: "ISA",
      deviceType: "Speed",
      deviceTypeId: 6,
    };
  }
  return {
    device: "IID",
    deviceType: "Interlock",
    deviceTypeId: 1,
  };
}

function programTypeFilter(programType) {
  programType = programType?.toLowerCase();

  if (
    programType === "administrative" ||
    programType === "administrative order"
  ) {
    return {
      programType: "Administrative Order",
    };
  }
  if (programType === "court" || programType === "court order") {
    return {
      programType: "Court Order",
    };
  }
  if (programType === "pre-trial" || programType === "pre-trial (texas only)") {
    return {
      programType: "Pre-Trial (Texas Only)",
    };
  }
  if (programType === "probation" || programType === "probation (texas only)") {
    return {
      programType: "Probation (Texas Only)",
    };
  }
  if (programType === "voluntary") {
    return {
      programType: "Voluntary",
    };
  }
}

function ClientTypeIdToDevice(clientTypeId) {
  switch (clientTypeId) {
    case 1:
    case 3:
    case 4:
      return "IID";
    case 6:
      return "ISA";
    default:
      return "PAM";
  }
}

function ClientTypeIdToDeviceType(clientTypeId) {
  switch (clientTypeId) {
    case 1:
    case 3:
    case 4:
      return "Interlock";
    case 6:
      return "Speed";
    default:
      return "Portable";
  }
}

//Added By Ankit Just to encode and decode pricing route

const dynamicSlug = false;
const storyNameToSlug = {};
const slugToStoryName = {};
let slugCounter = 0;

function encodeStory(name) {
  if (!dynamicSlug) return name;

  if (!storyNameToSlug[name]) {
    slugCounter += 1;
    const slug = `s${slugCounter}`;
    storyNameToSlug[name] = slug;
    slugToStoryName[slug] = name;
  }
  return storyNameToSlug[name];
}

function decodeStory(slug) {
  if (!dynamicSlug) return slug;
  return slugToStoryName[slug] || null;
}

function normalizeAddressComponents(components = []) {
  // return components.map((c) => ({
  //   long_name: c.nh || c.Eg,
  //   short_name: c.oh || c.Fg,
  //   types: c.mh || c.Dg||[],
  // }));
  if (!Array.isArray(components)) return [];

  return components.map((c) => {
    const longName = c.long_name || c.Eg || "";
    const shortName = c.short_name || c.Fg || "";
    const typesArr = c.types || c.Dg || [];

    return {
      long_name:
        typeof longName === "string" ? longName.trim() : String(longName),
      short_name:
        typeof shortName === "string" ? shortName.trim() : String(shortName),
      types: Array.isArray(typesArr) ? typesArr : [],
    };
  });
}

function normalizeCountryForPlus(countryValue, fallback = "USA") {
  if (countryValue === null || countryValue === undefined) return fallback;

  const raw = String(countryValue).trim();
  if (!raw) return fallback;

  const upper = raw.toUpperCase();
  if (
    upper === "US" ||
    upper === "USA" ||
    upper === "UNITED STATES" ||
    upper === "UNITED STATES OF AMERICA" ||
    upper.startsWith("UNI")
  ) {
    return "USA";
  }

  return raw;
}
